import React, { useEffect, useState } from 'react'
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper'
import IssuerNavigator from '../../components/DashBoard/IssuerNavigator'
import style from "./CompanyProfile.module.css";
import templateStyles from "../DashBoard/Templates/Templates.module.css"
import SM from '../../components/DashBoard/SM';
import API from "../../ApiConfig";
import { BASE_URL, DASHBOARD_METRICS, USER_TOKEN } from '../../Utils/constant';
import { Bar, BarChart, CartesianGrid, Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { AuthConsole, convertDateFormat } from '../../Utils/helper';
import cogoToast from 'cogo-toast-react-17-fix';
import useRefreshToken from '../../Hooks/usegenerateToken';
import { useSelector } from 'react-redux';
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042']

const DashboardMetrics = () => {
useRefreshToken(BASE_URL + USER_TOKEN)

  const [loading, setLoading]=useState(false)
  const No_of_Days=[
    {
      no_of_days:"Last 1 Week",
      days:7
    },
    {
      no_of_days:"Last 1 Month",
      days:30
    },
    {
      no_of_days:"Last 1 Year",
      days:365
    }

]


const [dateRange, setDateRange]=useState({startDate:"", endDate:""})
const[no_of_days, setNoofDays]=useState({no_of_days:"Last 1 Week", days:7})
const[dashboard, setDashboard]=useState("")
const barChartData = [
  { name: "Appeals Pending", value: dashboard.appeals_pending },
  { name: "Appeals Responded", value: dashboard.appeals_responded },
  { name: "Issuer Requests Pending", value: dashboard.issuer_requests_pending }

]

const pieChartData =
    dashboard.total_records_added_by_master_document?.map((doc) => ({
      name: doc.master_document_name,
      value: doc.count,
    })) || []
const getDashboardmetricsData=()=>{
  setLoading(true)
  API.get(DASHBOARD_METRICS,{
    params:{
      ...(dateRange.startDate && dateRange.endDate&&{start_date: convertDateFormat(dateRange.startDate)}),
      ...(dateRange.endDate && dateRange.startDate&&{end_date:convertDateFormat(dateRange.endDate)}),
      no_of_days:no_of_days.days
    }
  })

  .then(res=>{
    if(res.data.status==200){
      setLoading(false)
    setDashboard(res.data.data)
    }
    
  })  
  .catch(err=>{

    setLoading(false)
    cogoToast.error(err.response.data.message)
    AuthConsole(err);
    
  })
}
useEffect(()=>{


  getDashboardmetricsData()
},[no_of_days, dateRange])
const handleTime=(e)=>{
  setNoofDays(e)
}
const handleDateChange = (field, e) => {
  setDateRange((prev) => ({ ...prev, [field]: e }));
}

  return (
    <SlideUpWrapper direction="slide-left">
      <div
        className={[style.companyProfile, templateStyles.templateHeader].join(
          " "
        )}
      >
      </div>

      <div style={{ margin: "1rem" }}>
         <div style={{ margin: "1rem", display:"flex" }}>
        
                <div className={style.searchContainer}>
                    <div style={{display:"flex", alignItems:"center"}}>
                    {No_of_Days.map((item, index)=>(
                        <div key={index}>
                            <div className={`${style.noOfDays} ${no_of_days.days==item.days? style.selected:null}`} onClick={()=>handleTime(item)}>{item.no_of_days}</div>
                        </div>
                    ))}
                    <input
                                  type="date"
                                  className={style.datePicker}
                                  value={dateRange.startDate}
                                  style={{ margin: "0px 25px" }}
                                  onChange={(e) => handleDateChange("startDate", e.target.value)}
                                />
                                <input
                                  type="date"
                                  className={style.datePicker}
                                  value={dateRange.endDate}
                                  onChange={(e) => handleDateChange("endDate", e.target.value)}
                                />
                    </div>
                    </div>
                
                </div>
            <div style={{display:"flex", gap:"1rem", color:"gray"}}>

              <SM
                num={dashboard?.total_records_added??0}
                text="Total Record Added"
              />
              <SM
                num={dashboard?.records_added_last_month ??0}
                text="Record Added last months"
              />
              <SM

                num={dashboard?.requests_responded ??0}
                text="Request Responded"
              />
              <SM
                num={dashboard?.total_records_pending??0}
                text="Total Records Pending"
              />
              
            </div>




          <div style={{margin:"1rem 10px"}}>
            <ResponsiveContainer width={"100%"} height={300}>
            <BarChart data={barChartData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis allowDecimals={false} />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="value" nameKey="name">
                      {barChartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      ))}
                        </Bar>
                    </BarChart>
            </ResponsiveContainer>
        </div>
        <div>
          <h2>Records of Master Document Added</h2>
        {pieChartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={pieChartData}
                cx="50%"
                cy="50%"
                outerRadius={100}
                label
                dataKey="value"
              >
                {pieChartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <p style={{textAlign:"center", fontSize:"16px"}}>No records available by master document.</p>
        )}
         

         </div>
      </div>
      </SlideUpWrapper>
  )
}

export default DashboardMetrics